<template>
    <div>
    <div class="col-9 ms-auto me-5 px-3">
      <div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
        <div>
          <div class="body-title">Cambio de contraseña</div>
        </div>
        <div></div>
      </div>

      <div class="content-view">
        <form action="" class="px-3"  autocomplete="off" @submit.prevent="updateUser()">
          <div class="col-3 form-group">
            <label for="">Nombre de Usuario:</label>
            <input
              v-model="user.name"
              type="text" name="name"
              placeholder="Nombre"
              class="form-control"
              @keydown.enter="enterAsTab"
              required
            />
          </div>

          <div class="col-3 form-group mt-3">
            <label for="">Contraseña actual:</label>
            <div class="password-input">
              <input
                v-model="user.old_password"
                :type="showOldPassword ? 'text' : 'password'"
                placeholder="********"
                class="input input-password"
                @keydown.enter="enterAsTab"
                name="current-password"
                autocomplete="old-password"
                required
              />
              <span class="toggle-password" @click="showOldPassword = !showOldPassword ">

              <i :class="showOldPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </span>
            </div>
          </div>

          <div class="col-3 form-group mt-3">
            <label for="">Nueva contraseña:</label>

            <div class="password-input">
              <input
                v-model="user.new_password"
                :type="showNewPassword ? 'text' : 'password'"
                placeholder="********"
                class="input input-password"
                @keydown.enter="enterAsTab"
                autocomplete="new-password"
                required
              />
              <span class="toggle-password" @click="showNewPassword = !showNewPassword ">

              <i :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </span>
            </div>
          </div>

          <div class="mt-4 mb-3">
            <button type="submit" class="btn btn-success">Cambiar contraseña</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        showNewPassword:false,
        showOldPassword:false,
        user: {
          name: null
        }
      }
    },

    methods: {
      getCurrentUser(){
        axios.get('/user/get-current-user')
        .then(res => {
          this.user = res.data.user;
        })
      },

      updateUser(){
        axios.post('/user/update-password', this.user)
        .then(res => {
          Swal.fire({
            icon: "success",
            text: res.data.success,
            timer: 2000,
          });

          setTimeout(() => {
            window.location.href = "/";
          }, 3000);
        })
        .catch( (error) => {
          console.log("error:", error.response.data.error)
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `${error.response.data.error}`,
            timer: 4000,
            confirmButtonText : 'OK',
          })
        }
        )
      }
    },
    mounted(){
      this.getCurrentUser()
    }
  }
</script>

<style>
  :root {
    --white: #FFFFFF;
    --black: #000000;
    --very-light-pink: #C7C7C7;
    --text-input-field: #F7F7F7;
    --hospital-green: #ACD9B2;
    --sm: 14px;
    --md: 16px;
    --lg: 18px;
  }

  body {
    margin: 0;
    font-family: 'Quicksand', sans-serif;
  }

  .login {
    width: 100%;
    height: 100vh;
    display: grid;
    place-items: center;
  }

  .form-container {
    display: grid;
    grid-template-rows: auto 1fr auto;
    width: 300px;
  }

  .form {
    display: flex;
    flex-direction: column;
  }

  .form a {
    font-size: var(--sm);
    text-decoration: none;
    color: var(--hospital-green);
    text-align: center;
  }

  .logo {
    width: 200px;
    margin-bottom: 20px;
    justify-self: center;
    display: none;
  }

  .label {
    font-size: var(--sm);
    font-weight: bold;
    margin-bottom: 4px;
  }

  .input {
    width: 100%;
    height: 30px;
    border: none;
    border-radius: 8px;
    padding: 5px;
    margin-bottom: 12px;
    font-size: var(--md);
    background-color: var(--text-input-field);
  }

  .input-email {
    margin-bottom: 22px;
  }

  .primary-button {
    background-color: var(--hospital-green);
    color: var(--white);
    height: 50px;
    width: 100%;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: var(--md);
    font-weight: 550;
  }

  .secondary-button {
    height: 50px;
    width: 100%;
    margin-top: 50px;
    background-color: var(--white);
    color: var(--hospital-green);
    border: 1px solid var(--hospital-green);
    border-radius: 8px;
    font-size: var(--md);
    font-weight: 550;
    cursor: pointer;
  }

  .login-button {
    margin-top: 14px;
    margin-bottom: 30px;
  }

  .password-input {
    position: relative;
  }

  .toggle-password {
    position: absolute;
    top: 40%;
    right: 10px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .input-error {
    border: 1px solid #f06548;
  }

  .error-message {
    color: #f06548;
    font-size: 0.8em;
    margin-top: 5px;
    display: block;
    text-align: center !important;
  }

  @media (max-width: 640px) {
    .logo {
        display: block;
    }
    .signup-button {
        position: absolute;
        width: inherit;
        bottom: 25px;
    }
  }

</style>
